import { memo } from 'react';
import classnames from 'classnames';
import styles from './ItemCount.module.scss';

type Props = {
  totalNumberOfResults: number;
  className?: string;
};

const ItemCount = ({ totalNumberOfResults, className }: Props) => {
  const numItemsString =
    totalNumberOfResults === 1
      ? '1 item'
      : `${totalNumberOfResults.toLocaleString('en')} items`;

  return (
    <div
      className={classnames(styles.itemCount, className)}
      aria-live="polite"
      aria-label={numItemsString}
      role="status"
      data-testid="item-count"
    >
      {numItemsString}
    </div>
  );
};

export default memo(ItemCount);
